import { Alert } from '@noorden-insurtech/alba-design-system';
import { CircleAlert } from 'lucide-react';

interface AnalysisCriteriaAlertProps {
  messages: string[];
}

export function AnalysisCriteriaAlert({ messages }: AnalysisCriteriaAlertProps) {
  if (messages.length === 0) {
    return null;
  }

  const midPoint = Math.ceil(messages.length / 2);
  const firstColumn = messages.slice(0, midPoint);
  const secondColumn = messages.slice(midPoint);

  return (
    <Alert.Root status='warning'>
      <div className='flex h-[1.25rem] flex-shrink-0 items-start'>
        <CircleAlert
          className='size-8 text-alba-warning-orange-500'
          strokeWidth={2}
        />
      </div>
      <Alert.Content>
        <Alert.Title>Critérios que acionaram a análise</Alert.Title>
        <div className='grid grid-cols-1 gap-x-8 gap-y-1 md:grid-cols-2'>
          <ul className='list-disc space-y-1 pl-5 marker:text-alba-warning-orange-500'>
            {firstColumn.map((message, index) => (
              <li
                key={`${index}-${message}`}
                className='font-montserrat text-sm text-alba-black-500 underline'
              >
                {message}
              </li>
            ))}
          </ul>
          {secondColumn.length > 0 && (
            <ul className='list-disc space-y-1 pl-5 marker:text-alba-warning-orange-500'>
              {secondColumn.map((message, index) => (
                <li
                  key={`${index + midPoint}-${message}`}
                  className='font-montserrat text-sm text-alba-black-500 underline'
                >
                  {message}
                </li>
              ))}
            </ul>
          )}
        </div>
      </Alert.Content>
    </Alert.Root>
  );
}
